import classNames from 'classnames';
import { t } from 'ttag';

import { Image } from '@ui/Image';
import { Button } from '@ui/Button';
import {
  Modal,
  ModalProps,
} from '@ui/Modal';

import iconTop from './images/icon-top.png';
import iconPushUp from './images/icon-push-up.png';
import iconVip from './images/icon-vip.png';
import exampleTop from './images/example-top.png';
import examplePushUp from './images/example-push-up.png';
import exampleVip from './images/example-vip.png';

import s from './PromotionVariantsInfoModal.sss';

export const VARIANTS_LIST = [
  {
    icon: iconTop,
    title: () => t`ТОР в категорії`,
    description: () => t`Окремий блок в категорії і на сторінці товару`,
    example: {
      image: exampleTop,
      width: 130,
      height: 114,
    },
  },
  {
    icon: iconPushUp,
    title: () => t`Підняття вгору каталогу`,
    description: () => t`Оголошення піднімається на перше місце в каталозі, ніби його розмістили щойно`,
    example: {
      image: examplePushUp,
      width: 114,
      height: 129,
    },
  },
  {
    icon: iconVip,
    title: () => t`VIP на головній`,
    description: () => t`Ваше оголошення на головній сторінці Шафи`,
    example: {
      image: exampleVip,
      width: 154,
      height: 114,
    },
  },
];

export const PromotionVariantsInfoModal: React.FC<ModalProps> = ({
  className,
  onRequestClose,
  ...props
}) => (
  <Modal
    {...props}
    onRequestClose={onRequestClose}
    withClose={true}
    className={classNames(s.root, className)}
  >
    <ul className={s.list}>
      {VARIANTS_LIST.map(({ icon, title, description, example }, i) => (
        <li
          key={i}
          className={s.item}
        >
          <Image
            className={s.icon}
            src={icon}
            width="24"
            height="24"
          />
          <p className={s.title}>
            {title()}
          </p>
          <p className={s.description}>
            {description()}
          </p>

          <Image
            className={s.example}
            src={example.image}
            width={example.width}
            height={example.height}
          />
        </li>
      ))}
    </ul>

    <Button
      className={s.button}
      onClick={onRequestClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);
